import '../styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { Selector } from 'components/SmartChatView/Fields'
import { Button } from 'components/Form'
import { getStaticImage } from 'utils/statics'

const VirtualAssistantViewUI = ({ renderType, label, placeholder, renderedFields, vaOptions, vaCategoriesOptions, vaFaqsOptions, value, setRenderedFields, getVaOptions, getVaCategoriesOptions, getVaFaqsOptions, onChangeInner, tooltip, loadingVaOptions, loadingVaCategoriesOptions, loadingVaFaqsOptions, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <>
        {!renderedFields.includes('virtualAssistant') ? (
          <Button
            clearPrimary
            icon={
              <figure>
                <img src={getStaticImage('/icons/orange-brand/add-circle-icon-primary.svg')} alt='Add Virtual Assistant' />
              </figure>
            }
            value={I18n.t('smartchat_events_btn_assistant')}
            onClick={() => {
              getVaOptions()
              setRenderedFields(prevState => ([...prevState, 'virtualAssistant']))
            }}
          />
        ) : (
          <Selector
            isClearable
            label={label.virtualAssistant}
            placeholder={placeholder.virtualAssistant}
            options={vaOptions || []}
            value={value.virtualAssistant}
            onChange={value => {
              getVaCategoriesOptions(value.value)
              onChangeInner({ fieldType: 'virtualAssistant', fieldData: value })
            }}
            tooltip={tooltip.virtualAssistant}
            loading={loadingVaOptions}
            error={error?.virtualAssistant}
          />
        )}
        {value.virtualAssistant && (
          <Selector
            isRequired
            label={label.virtualAssistantCategory}
            placeholder={placeholder.virtualAssistantCategory}
            options={vaCategoriesOptions || []}
            value={value.virtualAssistantCategory}
            onChange={value => onChangeInner({ fieldType: 'virtualAssistantCategory', fieldData: value })}
            loading={loadingVaCategoriesOptions}
            error={error?.virtualAssistantCategory}
          />
        )}
        {value.virtualAssistantCategory && (
          !renderedFields.includes('virtualAssistantFaq') ? (
            <Button
              clearPrimary
              icon={
                <figure>
                  <img src={getStaticImage('/icons/orange-brand/add-circle-icon-primary.svg')} alt='Add Virtual Assistant FAQ' />
                </figure>
              }
              value={I18n.t('smartchat_events_btn_faqIntent')}
              onClick={() => {
                getVaFaqsOptions(value.virtualAssistant.value, value.virtualAssistantCategory.label)
                setRenderedFields(prevState => ([...prevState, 'virtualAssistantFaq']))
              }}
            />
          ) : (
            <Selector
              isClearable
              label={label.virtualAssistantFaq}
              placeholder={placeholder.virtualAssistantFaq}
              options={vaFaqsOptions || []}
              value={value.virtualAssistantFaq}
              onChange={value => onChangeInner({ fieldType: 'virtualAssistantFaq', fieldData: value })}
              loading={loadingVaFaqsOptions}
              error={error?.virtualAssistantFaq}
            />
          )
        )}
      </>
    )}
    {renderType === 'preview' &&  (
      <div className='action-view__virtual-assistant-preview'>
        <Selector
          placeholder={placeholder.virtualAssistant}
          options={vaOptions || []}
          value={value.virtualAssistant}
          onChange={value => onChangeInner({ fieldType: 'virtualAssistant', fieldData: value })}
          loading={loadingVaOptions}
          error={previewIntegrity.virtualAssistant}
        />
        <Selector
          placeholder={placeholder.virtualAssistantCategory}
          options={vaCategoriesOptions || []}
          value={value.virtualAssistantCategory}
          onChange={value => onChangeInner({ fieldType: 'virtualAssistantCategory', fieldData: value })}
          loading={loadingVaCategoriesOptions}
          error={previewIntegrity.virtualAssistantCategory}
        />
        <Selector
          placeholder={placeholder.virtualAssistantFaq}
          options={vaFaqsOptions || []}
          value={value.virtualAssistantFaq}
          onChange={value => onChangeInner({ fieldType: 'virtualAssistantFaq', fieldData: value })}
          loading={loadingVaFaqsOptions}
          error={previewIntegrity.virtualAssistantFaq}
        />
      </div>
    )}
  </div>
)

export default VirtualAssistantViewUI
